import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup'; // For validation
import { toast, ToastContainer } from 'react-toastify';
import Navbar from './Navbar';
import { forgetPassword, verifyOtpAndChangePasswords } from '../asiosConfig';
import Footer from './Footer';
import { mobileValidationSchema, verifyOTPValidationSchemas } from './ValidationSchema';

export const ForgotPassword = () => {
    const [step, setStep] = useState(1); // Step 1 for sending OTP, Step 2 for verifying OTP
    const [resendDisabled, setResendDisabled] = useState(false); // Control the resend link
    const [timeLeft, setTimeLeft] = useState(0); // Countdown timer for disabling resend link

    // Handle the resend link countdown
    useEffect(() => {
        let timer;
        if (resendDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
        } else if (timeLeft === 0) {
            setResendDisabled(false);
        }
        return () => clearInterval(timer);
    }, [resendDisabled, timeLeft]);

    // Formik setup
    const formik = useFormik({
        initialValues: {
            username: '',
            otp: '',
            password: '',
            confirm_password: '',
        },
        validationSchema: step === 1 ? mobileValidationSchema : verifyOTPValidationSchemas,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            if (step === 1) {
                // Step 1: Send OTP
                try {
                    const response = await forgetPassword({
                        Mobile_No: values.username,
                    });
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.data.message);
                        setStep(2); // Move to OTP verification step
                        startResendTimer(); // Start timer after successful OTP sending
                    } else {
                        toast.error(response.data.message);
                    }
                } catch (error) {
                    toast.error(error.response?.data?.message || 'Error sending OTP');
                }
            } else {
                // Step 2: Verify OTP and Change Password
                try {
                    const response = await verifyOtpAndChangePasswords({
                        mobile_number: values.username,
                        otp: values.otp,
                        password: values.password,
                        password_confirmation: values.confirm_password,
                    });

                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.data.message);
                        window.location.href = '/otpLogin'; // Redirect to login after success
                    } else {
                        toast.error(response.data.message);
                    }


                } catch (error) {
                    toast.error(error.response?.data?.message || 'Error verifying OTP or changing password');
                }
            }
            setSubmitting(false);
        },
    });

    // Function to start the resend countdown timer
    const startResendTimer = () => {
        setResendDisabled(true);
        setTimeLeft(60); // Set the countdown timer for 1 minute (60 seconds)
    };

    const handleResendOTP = async () => {
        try {
            const response = await forgetPassword({
                Mobile_No: formik.values.username,
            });
            if (response.status === 200 || response.status === 201) {
                toast.success(response.data.message);
                startResendTimer(); // Disable resend and start countdown again
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error resending OTP');
        }
    };

    return (
        <div>
            <Navbar />
            <section className="formBG mt-5">
                <div className="container">
                    <div className="formContent mt-5">
                        <h2>FORGOT PASSWORD</h2>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row justify-content-center align-items-center mt-2">
                                <div className="col-md-4">
                                    {step === 1 && (
                                        <div className='mb-3'>
                                            <label htmlFor="username" className='form-label'>Mobile Number</label>
                                            <input
                                                id="username"
                                                name="username"
                                                type="tel"
                                                className='form-control'
                                                placeholder='Enter 10-digit mobile number'
                                                value={formik.values.username}
                                                onChange={(e) => {
                                                    // Allow only numbers and limit to 10 digits
                                                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    formik.setFieldValue('username', value);
                                                }}
                                                onBlur={formik.handleBlur}
                                                maxLength={10}
                                                pattern="[0-9]{10}"
                                                title="Please enter exactly 10 digits (numbers only)"
                                            />
                                            {formik.touched.username && formik.errors.username ? (
                                                <div className="error">{formik.errors.username}</div>
                                            ) : null}
                                        </div>
                                    )}

                                    {step === 2 && (
                                        <>
                                            <div className='mb-3'>
                                                <label htmlFor="otp" className='form-label'>OTP</label>
                                                <input
                                                    id="otp"
                                                    name="otp"
                                                    type="text"
                                                    className='form-control'
                                                    placeholder='OTP'
                                                    value={formik.values.otp}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.otp && formik.errors.otp ? (
                                                    <div className="error">{formik.errors.otp}</div>
                                                ) : null}
                                            </div>

                                            <div className='mb-3'>
                                                <label htmlFor="password" className='form-label'>New Password</label>
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    className='form-control'
                                                    placeholder='Password'
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.password && formik.errors.password ? (
                                                    <div className="error">{formik.errors.password}</div>
                                                ) : null}
                                            </div>

                                            <div>
                                                <label htmlFor="confirm_password" className='form-label'>Confirm Password</label>
                                                <input
                                                    id="confirm_password"
                                                    name="confirm_password"
                                                    type="password"
                                                    className='form-control'
                                                    placeholder='Confirm Password'
                                                    value={formik.values.confirm_password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.confirm_password && formik.errors.confirm_password ? (
                                                    <div className="error">{formik.errors.confirm_password}</div>
                                                ) : null}
                                            </div>

                                            {/* Resend OTP Text */}
                                            <div className="text-end mt-2">
                                                <span
                                                    style={{ color: resendDisabled ? 'grey' : 'red', cursor: resendDisabled ? 'default' : 'pointer' }}
                                                    onClick={!resendDisabled ? handleResendOTP : null}
                                                >
                                                    Resend OTP {resendDisabled && <span className="text-muted small">{timeLeft}s</span>}
                                                </span>
                                                {/* {resendDisabled && <p className="text-muted small">Resend available in: {timeLeft}s</p>} */}
                                            </div>
                                        </>
                                    )}

                                    {/* Submit button will change based on step */}
                                    <div className="text-center d-grid mx-auto">
                                        <button type="submit" className='formBtn' disabled={formik.isSubmitting}>
                                            {step === 1 ? 'Send OTP' : 'Verify OTP and Change Password'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <Footer />
            <ToastContainer />
        </div>
    );
};
